(() => {
  const groupId = (item) => item?.properties?.['Reservation ID'];

  async function removeLinkedItems(line) {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    const chosen = cart.items[line - 1];
    const id = groupId(chosen);

    if (!id) return false;

    const updates = {};
    cart.items.forEach((item, index) => {
      if (groupId(item) === id) updates[item.key] = 0;
    });

    if (Object.keys(updates).length < 2) return false;

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!response.ok) throw new Error('Unable to update cart');
    window.location.reload();
    return true;
  }

  document.addEventListener(
    'click',
    async (event) => {
      const link = event.target.closest(
        'cart-remove-button a, a[href*="/cart/change"]'
      );
      if (!link) return;

      const url = new URL(link.href, window.location.origin);
      const line = Number(
        url.searchParams.get('line') ||
          link.closest('cart-remove-button')?.dataset?.index
      );
      if (!line) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        const removed = await removeLinkedItems(line);
        if (!removed) window.location.assign(link.href);
      } catch {
        window.location.assign(link.href);
      }
    },
    true
  );
})();